import dayjs              from 'dayjs';
import utc                from 'dayjs/plugin/utc';
import timezone           from 'dayjs/plugin/timezone';
import relativeTime       from 'dayjs/plugin/relativeTime';
import customParseFormat  from 'dayjs/plugin/customParseFormat';
import localizedFormat    from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/fr';
import 'dayjs/locale/en';

// todo: à voir si nécessaire
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

dayjs.locale('fr');

export default dayjs;